export type AppEnvironment = "local" | "staging" | "production";

export const PRODUCT_CODE = "seisaku-eye";
export const CITYWIDE_COMMON_SCHEMA = "citywide_common";
export const SEISAKU_EYE_SCHEMA = "seisaku_eye";

export function getAppEnvironment(): AppEnvironment {
  const configured = import.meta.env.VITE_APP_ENV?.trim();
  if (configured === "local" || configured === "staging" || configured === "production") return configured;

  if (typeof window === "undefined") return "staging";
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname.startsWith("staging.")) {
    return "staging";
  }
  return "production";
}

export function getAuthRedirectUrl() {
  const configured = import.meta.env.VITE_SUPABASE_AUTH_REDIRECT_URL?.trim();
  if (configured) return configured;
  if (typeof window === "undefined") return "";
  return window.location.origin;
}

export function getAIEndpoint() {
  return import.meta.env.VITE_AI_ENDPOINT?.trim() || "/api/ai/suggestions";
}
